import React, { useContext } from 'react';
import { FormText, FormGroup, Row } from 'reactstrap';
import _ from "lodash";
import FileInput from '../../components/molecules/FileInput';

export default function File({ context }) {
  const { file, fileName, handleFileSelection } = useContext(context);

  // We still need the old file name to display it to the user
  const oldFileName = _.cloneDeep(fileName);

  return (
    <FormGroup>
      <FileInput
        onFileChange={handleFileSelection}
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        helpText={
          <>
          <b>Carica un file</b> con le keywords ed eventualmente volumi <b>nel foglio RAW</b>
          </>
        }
        required={!(file || fileName)}
      />

      {/* Display the current file name if it exists */}
      {oldFileName && (
        <Row style={{ marginLeft: "0.5em" }}>
          <FormText color="muted" align={'left'}>
            <b>File attuale</b>: {oldFileName}
          </FormText>
        </Row>
      )}
    </FormGroup>
  )
}